import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './Stores';
import './Assets/Styles/index.css';
import './Assets/Styles/global.css';
import routes from './Routes';
import { RouterProvider } from 'react-router-dom';
import Favicon from 'react-favicon';
import SavvyDisplayFaviconStacked from './Assets/icons/SavvyDisplayFaviconStacked.png';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RouteContentFallback from './Components/RouteContentFallback';

const root = ReactDOM.createRoot(document.getElementById('root'));

const checkClarityId = {
  qa: {
    REACT_APP_API_LINK: 'https://savvy-qa.triggerpointmedia.click/api',
    REACT_APP_CLARITY_ID: 'onueofwe5s',
  },
  staging: {
    REACT_APP_API_LINK: 'https://savvy-demo.triggerpointmedia.click/api',
    REACT_APP_CLARITY_ID: 'onuf2nwk52',
  },
  production: {
    REACT_APP_API_LINK: 'https://app.savvydisplays.com/api',
    REACT_APP_CLARITY_ID: 'onucbp3zrb',
  },
};

const ClarityId =
  process.env.REACT_APP_API_LINK === checkClarityId.qa.REACT_APP_API_LINK
    ? checkClarityId.qa.REACT_APP_CLARITY_ID
    : process.env.REACT_APP_API_LINK ===
      checkClarityId.staging.REACT_APP_API_LINK
    ? checkClarityId.staging.REACT_APP_CLARITY_ID
    : checkClarityId.production.REACT_APP_CLARITY_ID;

window.CLARITY_ID_RESOLVE_CALLBACK(ClarityId);

root.render(
  <>
    <Provider store={store}>
      <div className="flex h-full max-h-full min-h-0 min-w-0 flex-col">
        <Favicon url={SavvyDisplayFaviconStacked} />

        <Suspense fallback={<RouteContentFallback fullScreen />}>
          <RouterProvider router={routes} />
        </Suspense>
      </div>
    </Provider>
    <ToastContainer
      autoClose={1000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      pauseOnHover
      theme="light"
    />
  </>
);
